import { TokenSession } from '@avangard/utils/token';
import { changePlatform } from '@avangard/utils/routing';

import type { ApolloClient } from '@apollo/client';

const logout = async (client: ApolloClient<any>): Promise<any> => {
    const refreshToken = TokenSession.getCurrentSession().getRefreshToken().getToken();

    if (!refreshToken) {
        return;
    }

    TokenSession.destroyCurrentSession();
    await client.clearStore();

    changePlatform();
};

export { logout };
